// import { error } from "console";
import { ActionTypes } from "../constants/action-types";

const initialState={
    // blogImage:[],
    blogImage:{},
    allAuthImages:[],
    loading:false,
    error:null,
};
//
const blogImageReducer=(state=initialState,action)=>{
    switch(action.type){
        
    case ActionTypes.FETCH_BLOG_IMAGE_REQUEST:
        return { ...state, loading: true, error: null };
        

                
    case ActionTypes.FETCH_BLOG_IMAGE_SUCCESS:
                 console.log('Reducer received images:', action.payload.blogId);
                //  console.log('reducer image type:',typeof(blogImage))

        return { ...state, loading: false, blogImage: {...state.blogImage,
            [action.payload.blogId]: action.payload.data,},}

            case ActionTypes.FETCH_AUTH_ARCHIVE_SUCCESS:
                return{
                    ...state,loading:false,
                    allAuthImages:action.payload,
                }
            
        

    case ActionTypes.FETCH_BLOG_IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case ActionTypes.FETCH_AUTH_ARCHIVE_FAILURE:
        return  {...state,loading:false,error:action.payload}

      
            default:
                return state;
}
};
export default blogImageReducer;
